module.exports = function (maxZoom) {
  var html = "\n    <div id=\"game_board_sizer\" class=\"game_board_sizer\">\n    <i class=\"fa fa-arrows-alt\"></i>\n    <input type=\"range\" min=\"2\" max=\"".concat(maxZoom, "\" value=\"100\" />\n    </div>\n    ");
  return html;
};